import { INFORMATION_PATH } from 'distributions/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DistributionInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/show/routes/information/index.js